// Copyright (c) 2019 Deere & Company

import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-balham.css';
import './index.scss';
import * as busyCounter from '../../../shared/action-creator/busy-counter';
import React, { Component } from 'react';
import { getDateFormat, getOnlyValues } from '../../common';
import { AgGridReact } from 'ag-grid-react';
import BusyCounterLoadingIndicator from '../../../shared/components/busyCounter/busy-counter-loading-indicator';
import ExpandedClaimTableColumnDefinitions from '../../column-definition';
import PropTypes from 'prop-types';
import ShortClaimTableColumnDefinitions from '../../column-definition-short-view';
import { WarningAlertBar } from '../../../shared/components/alert-bar';
import { connect } from 'react-redux';
import { filterEmpty } from '../../../shared/services/validator';
import { getFactoryByCode } from '../../../app/common/repositories';
import { showLoadingIndicator } from '../../../shared/state/busy-counter';


const rowSelection = 'single';

class SearchResultPanel extends Component {

    state = {

        selectedGridRow: {},
        factory: '',
        productSeriesIds: '',
        productSubSeriesIds: '',
        baseCodeIds: '',
        regionCode: '',
        branchIds: [],
        warningAlertOpen: true,
    };

    componentWillMount = () => {

        this.props.editedInputs.map( item => {

            switch ( item[0] ) {

            case 'factoryCode': this.getFactoryByCode( item[1] ); break;
            case 'productSeriesIds':
            case 'productSubSeriesIds':
            case 'baseCodeIds':
            case 'factoryClaimTypeIds':
            case 'branchIds': this.updateState( item[0], getOnlyValues( item[1] ) ); break;
            case 'regionCode': this.updateState( 'regionCode', item[1] ); break;
            default: break;

            }
            return true;

        } );

    }

    onGridReady = params => {

        const columnsToBeHide = [];
        const allColumnIds = [];
        const searchViewOption = this.props.searchedOptions;
        this.gridApi = params.api;
        this.columnApi = params.columnApi;


        try {

            this.gridApi.context.beanWrappers.tooltipManager
                .beanInstance.MOUSEOVER_SHOW_TOOLTIP_TIMEOUT = 0;

        } catch ( e ) {}

        if ( !searchViewOption.includeComplaintCauseCorrection ) {

            columnsToBeHide.push( 'language', 'complaint', 'cause', 'correction', 'lastClaimNumber' );

        }
        if ( !searchViewOption.includeRejects ) {

            columnsToBeHide.push( 'claimStatusCode' );

        }
        if ( !searchViewOption.include17CharacterPin ) {

            columnsToBeHide.push( 'pin.digit17' );

        }

        if ( !searchViewOption.includeAttachmentCount ) {

            columnsToBeHide.push( 'attachmentCount' );

        }
        if ( this.columnApi && this.columnApi.setColumnsVisible ) {

            this.columnApi.setColumnsVisible( columnsToBeHide, false );

        }

        const columns = this.columnApi && this.columnApi.getAllColumns ?
            this.columnApi.getAllColumns() : [];

        columns.forEach( column => {

            allColumnIds.push( column.colId );

        } );

        if ( this.columnApi && this.columnApi.autoSizeColumns && allColumnIds.length > 0 ) {

            this.columnApi.autoSizeColumns( allColumnIds, true );

        }

        this.props.updateGridAPI( this.gridApi );

    };


    onSelectionChanged () {

        const selectedRows = this.gridApi.getSelectedRows();
        let selectedRowsString = '';
        selectedRows.forEach( ( selectedRow, index ) => {

            if ( index !== 0 ) {

                selectedRowsString += ', ';

            }
            selectedRowsString = selectedRow;

        } );
        this.setState( {
            selectedGridRow: selectedRowsString,
        } );

    }

    onBtExport () {

        this.gridApi.exportDataAsCsv( {

            processCellCallback: function formatCell ( cell ) {

                const colDef = cell.column.colDef;
                const valueFormatter = colDef.valueFormatter;

                if ( typeof valueFormatter === 'function' ) {

                    return valueFormatter( {
                        value: cell.value,
                        data: cell.node && cell.node.data,
                        node: cell.node,
                        colDef,
                        column: cell.column,
                        context: cell.context,
                    } );

                }

                return cell.value;

            },

        } );

    }

    onModify () {

        this.props.onEditSearch();

    }


    onClear () {

        this.props.onNewSearch();

    }

    updateState = ( propertyName, propertyValue ) => {

        this.setState( {
            [propertyName]: propertyValue,
        } );

    }


    getFactoryByCode = factoryCode => {

        if ( factoryCode !== '-1' ) {

            getFactoryByCode( factoryCode ).then( response => {

                this.updateState( 'factory', response.factoryDescription );

            } );

        }

    }

    onClaimClick = element => {

        const elementName = element.event.target.name;
        if ( elementName ) this.props.onClaimDetails( element.node.rowIndex );

    }

    getSearchedValue = ob => {

        const searchedVal = ob[1];
        const searchedName = ob[0];

        switch ( searchedName ) {

        case 'factoryCode': return this.state.factory;
        case 'serialNumber': return `${searchedVal.from} - ${searchedVal.to}`;
        case 'buildDate':
        case 'processDate': return `${getDateFormat( searchedVal.from, searchedName )} - ${getDateFormat( searchedVal.to, searchedName )}`;
        case 'buildMonth': return `${getDateFormat( searchedVal.from, searchedName )} - ${getDateFormat( searchedVal.to, searchedName )}`;
        case 'productSeriesIds': return this.state.productSeriesIds;
        case 'productSubSeriesIds': return this.state.productSubSeriesIds;
        case 'baseCodeIds': return this.state.baseCodeIds;
        case 'branchIds': return this.state.branchIds;
        case 'regionCode': return this.state.regionCode;
        case 'factoryClaimTypeIds': return this.state.factoryClaimTypeIds;
        case 'pins':
        case 'pipNumbers':
        case 'claimNumbers':
        case 'partNumber': return this.searchResultHeader( searchedVal );
        case 'supplierId': return this.searchResultHeader( searchedVal );
        case 'partDescription': return searchedVal;
        case 'selectedOptionList': return this.state.selectedOptionList;
        case 'modelCdList': return this.searchResultHeader( searchedVal );
        default: return searchedVal.toString();

        }


    }


     searchResultHeader = propertyValue => {

         const arr = filterEmpty( propertyValue );
         if ( arr.length > 4 ) {

             return `${arr.length} selected`;

         }
         return arr.join( ', ' );

     }

     searchHeader = propertyValue => {

         const arr = filterEmpty( propertyValue );

         return arr.join( ', ' );

     }

     dismissHandler = () => {

         this.setState( {
             warningAlertOpen: false,
         } );

     }

     render () {

         const errMessage = 'Limited Results Displayed!!! Please Enter Additional/Narrower Search Criteria to get Full Results.';
         const defaultColDef = { resizable: true };
         const items = this.props.editedInputs.map( item => (
             <div className="header-style">
                 <label>{this.props.searchedLabels[item[0]]}</label>
                 <div className="headerResult-style">
                     <span>{this.getSearchedValue( item )}</span>
                 </div>
             </div>
         ) );

         return (
             <div>
                 <section>
                     <BusyCounterLoadingIndicator busyCounter={this.props.busyCounter} />
                     {this.props.claimList.length >= 5000 &&
                     this.state.warningAlertOpen === true && (
                         <WarningAlertBar
                             alertTitle="Warning"
                             dismissHandler={this.dismissHandler}
                             // canDismiss={true}
                             // willAutoDismiss={true}
                             // timeoutLength="15000"
                         >
                             {errMessage}
                         </WarningAlertBar>
                     ) }
                     <header>

                         <h2 className="page-header">
                            Claim Search - {this.props.claimList.length} Results
                             <i className="fa fa-refresh result-page-refesh" aria-hidden="true" onClick={this.props.onSubmit} title="Refresh" />
                             <button className="primary-button" onClick={this.onBtExport.bind( this )} type="button"><span> Export to CSV </span></button>
                             <button className="primary-button" onClick={this.onModify.bind( this )} type="button"><span> Edit Search </span></button>
                             <button className="primary-button" onClick={this.onClear.bind( this )} type="button"><span> New Search </span></button>

                             {this.props.callFrom === 'findClaim' && (
                                 <div className="downloadwrp">
                                     <div className="dropdown">

                                         <button className="report-button dropdown-toggle" type="button" id="dropdownMenuButton2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" onClick={this.props.onToggleDiv}>
                                             <span className="downlaod">Download Report</span>
                                             <i className={`fa fa-caret-down ${this.props.showDropDownMenu ? 'up' : ''}`} />
                                         </button>

                                         <div className={`dropdown-menu ${this.props.showDropDownMenu ? ' show ' : 'hide'}`} aria-labelledby="dropdownMenuButton1">
                                             <span href="#" className="dropdown-item default-report" onClick={this.props.onSubmit}>Default Report</span>
                                             <span href="#" className="dropdown-item replacement-part-report" onClick={this.props.onSubmit}>Replacement Part Report</span>
                                             <span href="#" className="dropdown-item factory-report" onClick={this.props.onSubmit}>Factory Data Extract Report</span>
                                             <span href="#" className="dropdown-item text-extract-report" onClick={this.props.onSubmit}>Text Extract Report</span>
                                             <span href="#" className="dropdown-item analysis-comments-report" onClick={this.props.onSubmit}>Analysis Comments Report</span>
                                         </div>
                                     </div>

                                 </div>
                             ) }
                         </h2>
                         <div className="headerPanel-style">
                             {items}
                         </div>


                     </header>
                     <main>
                         <section className="search-result-panel">
                             <div
                                 className="ag-theme-balham ag-theme-popupbg"
                             >
                                 <AgGridReact
                                     columnDefs={this.props.searchedOptions
                                         .includeExpandedClaimDetail ?
                                         ExpandedClaimTableColumnDefinitions :
                                         ShortClaimTableColumnDefinitions}
                                     defaultColDef={defaultColDef}
                                     rowData={this.props.claimList}
                                     onGridReady={this.onGridReady}
                                     handleClick={rowSelection}
                                     onCellClicked={this.onClaimClick.bind( this )}
                                     onSelectionChanged={this.onSelectionChanged.bind( this )}
                                     selectedGridRow={this.state.selectedGridRow}
                                     popupParent={document.body}
                                     enableCellTextSelection={true}
                                 />
                             </div>
                         </section>
                     </main>
                 </section>
             </div>
         );

     }

}


SearchResultPanel.displayName = 'SearchResultPanel';
SearchResultPanel.propTypes = {
    searchedOptions: PropTypes.object.isRequired,
    claimList: PropTypes.array.isRequired,
    onEditSearch: PropTypes.func.isRequired,
    onNewSearch: PropTypes.func.isRequired,
    getSearchList: PropTypes.func.isRequired,
    searchedLabels: PropTypes.object.isRequired,
    onClaimDetails: PropTypes.func.isRequired,
    editedInputs: PropTypes.array.isRequired,
    updateGridAPI: PropTypes.func.isRequired,
    onToggleDiv: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    showDropDownMenu: PropTypes.bool.isRequired,
    callFrom: PropTypes.string.isRequired,
    busyCounter: PropTypes.bool.isRequired,
};
const mapStateToProps = state => ( {
    busyCounter: showLoadingIndicator( state.application.busyCounter ),
} );
const mapDispatchToProps = dispatch => ( {
    increaseCounter: () => dispatch( busyCounter.increaseBusyCounter() ),
    decreaseCounter: () => dispatch( busyCounter.decreaseBusyCounter() ),
} );
export default connect( mapStateToProps, mapDispatchToProps )( SearchResultPanel );
